import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { SelectComponent, SelectOption } from '../select/select.component';

@Component({
  selector: 'app-page-size-select',
  imports: [SelectComponent],
  template: `
    <div class="page-size-select">
      <app-select
        id="page-size-select"
        [label]="label()"
        [options]="selectOptions()"
        [value]="String(value())"
        [placeholder]="placeholder()"
        (valueChange)="onValueChange($event)"
      />
    </div>
  `,
  styleUrl: './page-size-select.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'contents' },
})
export class PageSizeSelectComponent {
  options = input<number[]>([12, 24, 48]);
  value = input<number>(24);
  label = input<string>('');
  placeholder = input<string>('Por página');

  valueChange = output<number>();

  protected readonly String = String;

  protected selectOptions = computed<SelectOption[]>(() =>
    this.options().map(n => ({ value: String(n), label: String(n) })),
  );

  protected onValueChange(val: string): void {
    this.valueChange.emit(Number(val));
  }
}
